module.exports = __webpack_public_path__ + "img/vertical_6_2_8023.9da920c9.png";